import React from "react";
import './Checkbox.scss';

export const Checkbox = (props) => {
  return ( 
     <label className={`${props.className} custom_checkbox`}>{props.label}
          <input type="checkbox" checked={props.checked} id={props.id} onChange={props.onChange} />
          <span className="checkmark"></span>
    </label>
  );
};